export enum WebcastStatusForVotes{
  UPCOMING = 'UPCOMING',
  PENDING = 'PENDING',
  LIVE = 'LIVE',
  COMPLETE = 'COMPLETE'
}

export interface VotesViewProps {
  votes: Vote[]
  createVote (vote:Vote): void
  deleteVote (id:number): void
  editVote (vote:Vote): void
  endVote (id:number): void
  endAllVotes (): void
  startVote (id:number): void
  setMode (payload: VotesSetModePayload): void
  mode: VotesMode
  selectedVoteId?: number
  countdownStart?: number
  clearCountdown(): void
  webcastStatus: WebcastStatusForVotes
}

export enum VoteStatus {
  notstarted = 'notstarted',
  open = 'open',
  closed = 'closed'
}


export enum VotesMode {
  DETAILS = 'DETAILS',
  EDIT = 'EDIT',
  ERROR = 'ERROR',
  LIST = 'LIST',
  RESULTS = 'RESULTS'
}

export interface VotesSetModePayload{
  mode: VotesMode
  selectedVoteId?: number
}

export interface Option {
  id?: string
  total?: number
  value: string
}

export interface Vote {
  question: string
  options: Option[]
  id?: number
  lastUpdated?: string
  status?: VoteStatus
  pendingChange?: boolean
}

export enum VotesErrorType {
  DELETE_CONFIRMATION = 'DELETE_CONFIRMATION',
  START_NEW_POLL = 'START_NEW_POLL',
  CHANGE_DURING_LIVE = 'CHANGE_DURING_LIVE',
  DUPLICATE_ANSWER = 'DUPLICATE_ANSWER',
  INSUFFICIENT_DATA = 'INSUFFICIENT_DATA',
  SERVER_ERROR = 'SERVER_ERROR'
}

export interface VotesAlertProps {
  error: VotesErrorType
  confirmHandler():void
  cancelHandler?():void
}

export interface PollsAlertData {
  errMsg: string
  confirmMsg: string
  btnText: string
  btnBdd: string
  cancelBtn: boolean
}

export interface PollQuestionListItemProps {
  key: any
  question: string
  id?: number
  status?: VoteStatus
  setMode (payload: VotesSetModePayload): void
}

export interface VotesListProps {
  votes: Vote[]
  setMode (payload: VotesSetModePayload): void
  webcastStatus: WebcastStatusForVotes
}

export interface EditQuestionProps extends Vote {
  setMode (payload: VotesSetModePayload): void
  deleteVote (id:number): void
  editVote (vote:Vote): void
  startVote (id:number): void
  webcastStatus: WebcastStatusForVotes
}

export interface VoteDetails extends EditQuestionProps {
  openVoteId: number | undefined
  id: number
}

export interface OpenQuestionProps extends Vote {
  setMode (payload: VotesSetModePayload): void
  createVote (vote:Vote): void
  editVote (vote:Vote): void
}

export interface VotesResultsProps {
  question: string
  options: Option[]
}

export interface VotesResultsViewProps extends VotesResultsProps {
  setMode (payload: VotesSetModePayload): void
  countdownStart?: number
  clearCountdown(): void
  endVote (id:number): void
  id?: number,
  status: VoteStatus
}

export interface PercentageBoxProps {
  percentage: number
}

export interface VoteCountdownProps {
  clearCountdown(): void
  countdownStart: number
}

export interface BackToList {
  setMode (payload: VotesSetModePayload): void
}

